export enum RolesEnum {
  'Project member' = 1,
  'Project admin' = 2,
  'Project leader' = 4,
  'Platform admin' = 8,
  'Super user' = 16,
  'Application admin' = 32,
  'Agent builder' = 64,
}

export const RolesArray = [
  { roleId: 1, roleName: 'Project Member', roleDescription: 'Can view and participate in projects.' },
  { roleId: 2, roleName: 'Project Admin', roleDescription: 'Can manage project settings and users.' },
  { roleId: 4, roleName: 'Project Leader', roleDescription: 'Leads the project with full permissions.' },
  { roleId: 8, roleName: 'Platform Admin', roleDescription: 'Manages platform-level configurations.' },
  { roleId: 16, roleName: 'Super User', roleDescription: 'Has advanced permissions across the platform.' },
  { roleId: 32, roleName: 'Application Admin', roleDescription: 'Manages application settings and configurations.' },
  { roleId: 64, roleName: 'Agent builder', roleDescription: 'Can build and configure agents.' },
]

export const deriveRoleNamesFromRoleNumber = (roleNumber: number) => {
  const roles = []
  if ((roleNumber & 1) > 0) roles.push(RolesArray[0].roleName)
  if ((roleNumber & 2) > 0) roles.push(RolesArray[1].roleName)
  if ((roleNumber & 4) > 0) roles.push(RolesArray[2].roleName)
  if ((roleNumber & 8) > 0) roles.push(RolesArray[3].roleName)
  if ((roleNumber & 16) > 0) roles.push(RolesArray[4].roleName)
  if ((roleNumber & 32) > 0) roles.push(RolesArray[5].roleName)
  if ((roleNumber & 64) > 0) roles.push(RolesArray[6].roleName)
  return roles
}

export const deriveRoleIdsFromRoleNumber = (roleNumber: number) => {
  const roles = []
  if ((roleNumber & 1) > 0) roles.push(1)
  if ((roleNumber & 2) > 0) roles.push(2)
  if ((roleNumber & 4) > 0) roles.push(4)
  if ((roleNumber & 8) > 0) roles.push(8)
  if ((roleNumber & 16) > 0) roles.push(16)
  if ((roleNumber & 32) > 0) roles.push(32)
  if ((roleNumber & 64) > 0) roles.push(64)
  return roles
}

export const deriveRoleNumberFromRoleIds = (roleIds: number[]) => {
  return roleIds.reduce((acc, roleId) => acc | roleId, 0)
}

export const roleCanBeAssigned = (roleNumber: number, userRole: number) => {
  if (userRole & 16) return true
  else if (userRole & 32 && roleNumber != 16) return true
  else if (roleNumber <= userRole) return true

  return false
}

export const isProjectMember = (roleNumber: number): boolean => (roleNumber & RolesEnum['Project member']) > 0
export const isProjectAdmin = (roleNumber: number): boolean => (roleNumber & RolesEnum['Project admin']) > 0
export const isProjectLeader = (roleNumber: number): boolean => (roleNumber & RolesEnum['Project leader']) > 0
export const isPlatformAdmin = (roleNumber: number): boolean => (roleNumber & RolesEnum['Platform admin']) > 0
export const isSuperUser = (roleNumber: number): boolean => (roleNumber & RolesEnum['Super user']) > 0
export const isApplicationAdmin = (roleNumber: number): boolean => (roleNumber & RolesEnum['Application admin']) > 0
export const isAgentBuilder = (roleNumber: number): boolean => (roleNumber & RolesEnum['Agent builder']) > 0

export const hasSubscriptionAccess = (roles: number) =>
  isProjectAdmin(roles) || isProjectLeader(roles) || isPlatformAdmin(roles) || isSuperUser(roles)
// export const hasImageAccess = (roles: number) =>
//   isProjectAdmin(roles) || isProjectLeader(roles) || isPlatformAdmin(roles) || isSuperUser(roles)
export const hasApplicationsAccess = (roles: number) => isSuperUser(roles) || isApplicationAdmin(roles)
export const hasDocumentationAccess = (roles: number) =>
  isSuperUser(roles) || isPlatformAdmin(roles) || isApplicationAdmin(roles)

export function isValidRoles(value: number): value is RolesEnum {
  const validRoles = [0, 1, 2, 4, 8, 16, 32, 64]
  // Check if the value is a valid combination of the allowed roles
  return validRoles.reduce((acc, role) => acc && (value & ~role) >= 0, true)
}
